module.exports = __webpack_public_path__ + "img/profile.63ee76e8.svg";